export default __webpack_public_path__ + "static/media/bonus-code-ico.d4bc9464.svg";